module.exports = __webpack_public_path__ + "static/media/nima_play_jhali_body01.1709bb78.gif";